import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  root: {
    width: '100%',
    flex: 1,
    backgroundBlendMode: 'multiply',
    textShadow: `black 0 0 ${theme.spacing(5)}, black 0 0 ${theme.spacing(4)}`,
    justifyContent: 'space-evenly',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    overflow: 'hidden',
    position: 'relative',
    height: theme.spacing(23.75),
    minHeight: theme.spacing(23.75),
    maxHeight: theme.spacing(23.75),

    '& img': {
      width: '100%',
      height: theme.spacing(23.75),
      minHeight: theme.spacing(23.75),
      maxHeight: theme.spacing(23.75),
      objectFit: 'cover',
    },
  },

  textContainer: {
    width: '100%',
    height: '100%',
    position: 'absolute',
    justifyContent: 'space-evenly',
    display: 'flex',
    flexDirection: 'column',
  },

  gameTitle: {
    '&.MuiTypography-root': {
      lineHeight: 1,
      textAlign: 'center',
      fontSize: `max(${theme.spacing(3.25)}, min(${theme.spacing(3.75)}, 3vw))`,
      flexFlow: 'inherit',
      flex: '0 0 auto',
      letterSpacing: '0.05em',
      fontFamily: '"Bebas Neue"',
    },
    [theme.breakpoints.up(320)]: {
      '&.MuiTypography-root': {
        fontSize: `max(${theme.spacing(2)}, min(${theme.spacing(3.75)}, 3vw))`,
      },
    },
  },

  title: {
    '&.MuiTypography-root': {
      lineHeight: 1,
      textAlign: 'center',
      fontFamily: 'Bebas Neue',
      height: theme.spacing(6.75),
      // margin: theme.spacing(1.625, 0),
      fontSize: `max(${theme.spacing(4.5)}, min(${theme.spacing(9)}, 5vw))`,
    },
    [theme.breakpoints.up(320)]: {
      '&.MuiTypography-root': {
        height: 'auto',
        fontSize: `max(${theme.spacing(3)}, min(${theme.spacing(9)}, 5vw))`,
      },
    },
  },

  timer: {
    '& .MuiTypography-root': {
      fontSize: theme.spacing(3),
      padding: theme.spacing(1, 2),
      borderRadius: theme.shape.borderRadius,
      backgroundColor: theme.palette.bannerTimer.background,
    },
  },
}));
